import { useField } from "formik";
import React, { ReactNode } from "react";
import xor from "lodash/xor";
import { CheckboxProps, FormControl, FormControlLabel, FormHelperText } from "@mui/material";
import { FormControlLabelProps } from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

export interface CheckboxFormikProps
  extends Omit<CheckboxProps, "name" | "onChange" | "onBlur" | "error"> {
  name: string;
  label?: ReactNode;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  status?: boolean;
}

const CheckboxFormik = ({
  name,
  label,
  value,
  labelPlacement,
  status,
  ...props
}: CheckboxFormikProps) => {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const isArrayField = Array.isArray(field.value);
  const currentValue = field.value ?? (isArrayField ? [] : false);
  const checked = isArrayField ? currentValue.includes(value) : Boolean(currentValue);

  const showError = Boolean(meta.touched && meta.error);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isArrayField) {
      const updated = xor(currentValue, [value]).filter(Boolean);
      setValue(updated);
    } else {
      setValue(event.target.checked ?? false);
    }
  };

  return (
    <FormControl error={showError}>
      <FormControlLabel style={{display: "grid", gridTemplateColumns: "0fr 1fr", paddingTop: '5px', paddingBottom: '5px'}}
        control={
          <Checkbox
            {...props}
            name={name}
            checked={checked}
            onChange={handleChange}
            disabled={status}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
        disabled={status}
        onBlur={field.onBlur}
      />
      {showError && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CheckboxFormik;